<a [href]="providerProfileUrl" target="_blank" *ngIf="providerUsername" class="d-flex gap-2 align-items-center">
  <img class="rounded-circle" [src]="providerProfileImageUrl" [height]="25">
  {{ providerUsername }}
</a>
